var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('stock-table',{key:_vm.index,attrs:{"url-create":"BuyBySuppilier","url-api":"/stock","headers":_vm.headers,"no-search":true},scopedSlots:_vm._u([{key:"product",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{on:{"click":function($event){return _vm.$router.push({
            name: 'ProductDetail',
            params: { id: item.product_id },
          })}}},[_vm._v("\n        mdi-link-variant\n      ")]),_vm._v("\n      "+_vm._s(_vm._f("capitalize")(item.product.name))+"\n    ")]}},{key:"warehouse",fn:function(ref){
          var item = ref.item;
return [_c('v-icon',{on:{"click":function($event){return _vm.$router.push({
            name: 'WarehouseDetail',
            params: { id: item.warehouse_id },
          })}}},[_vm._v("\n        mdi-link-variant\n      ")]),_vm._v("\n      "+_vm._s(_vm._f("capitalize")(item.warehouse.name))+"\n    ")]}},{key:"cost",fn:function(ref){
          var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm._f("currency")(item.cost))+"\n    ")]}},{key:"price",fn:function(ref){
          var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm._f("currency")(item.price))+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }